import "../../../styles/menu.scss";

import Icon, { iconColor } from "./Icon.jsx";

import DropDown from "./DropDown";
import PropTypes from "prop-types";
import React from "react";

export class SubMenuItem extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            active: false,
        };
        this.wrapperRef = React.createRef();

        this.onClick = this.onClick.bind(this);
        this.onClickHide = this.onClickHide.bind(this);
    }
    onClick(event) {
        event.stopPropagation();
        event.preventDefault();

        const {
            dropDownChildren,
            dropDownStyle,
            dropDownShiftLeft,
            setDropDown,
            isDroppedDown,
            below,
        } = this.props;
        
        if( this.state.active ){
            setDropDown(null);
        } else {
            if (this.props.disabled) {
                return;
            }
            
            const childrenDropDownWithProps = [];
            if( dropDownChildren ){
                React.Children.forEach(dropDownChildren, function(child, index) {
                    if( child ) {
                        childrenDropDownWithProps.push( React.cloneElement(child, {
                            key: index,
                        }) );
                    }
                });
            }
            setDropDown(
                <DropDown setDropDown={setDropDown} rect={this.wrapperRef.current.getBoundingClientRect()} below={below} isDroppedDown={isDroppedDown} style={dropDownStyle} shiftLeft={dropDownShiftLeft} onComponentWillUnmount={this.onClickHide}>
                    {childrenDropDownWithProps}
                </DropDown>
            );
        }
        this.setState({
            active: !this.state.active,
        });
    }
    onClickHide(event) {
        if( event ){
            event.stopPropagation();
            event.preventDefault();
        }
        this.props.setDropDown(null);
        this.setState( () => ({
            active: false,
        }));
    }
    render() {
        const {
            border,
            children,
            color,
            darkTheme,
            disabled,
            expand,
            flex,
            iconType,
            interactive,
            onClick,
            roundCornerTopLeft,
            roundCornerTopRight,
            side,
            style
        } = this.props;
        const isActive = this.state.active;

        let className = "sub-menu-item";
        className += ` ${side}`;
        className += roundCornerTopLeft ? " corner-left" : "";
        className += roundCornerTopRight ? " corner-right" : "";
        className += interactive ? "" : " not-interactive";
        className += (isActive || darkTheme) ? " active" : "";
        className += flex ? " flex" : "";
        if( !border ) {
            className += " no-border";
        } else if(isActive || darkTheme) {
            className += " dark-border";
        }
        if (disabled) {
            className += " disabled";
        }

        return (
            <div className={className} onClick={onClick?onClick:this.onClick} style={{flexGrow:expand?"1":undefined, ...style}} ref={this.wrapperRef}>
                {iconType && (
                    <Icon type={iconType} className={flex ? "" : "menu-icon"} color={(darkTheme || isActive)?iconColor.white:color}/>
                )}
                {children && (
                    children
                )}
            </div>
        );
    }
}
SubMenuItem.propTypes = {
    // function called when item is clicked
    onClick: PropTypes.func,
    // children displayed inside the MenuItem
    children: PropTypes.node,
    // children displayed inside dropdown menu
    dropDownChildren: PropTypes.node,
    // required if dropDownChildren is set
    setDropDown: PropTypes.func,
    // if drop down should be pushed left or right
    dropDownShiftLeft: PropTypes.bool,
    // style for the dropdown
    dropDownStyle: PropTypes.object,
    // style for the sub-menu-item itself
    style: PropTypes.object,
    // expands: flex-grow: 1
    expand: PropTypes.bool,
    // iconType displayed in the menuItem
    iconType: PropTypes.string,
    // default: true, if set to true no inputs will be registered
    interactive: PropTypes.bool,
    // default: "left", can be "right" will then float: right
    side: PropTypes.string,
    // default: false, if true border-top-left-radius will be set
    roundCornerTopLeft: PropTypes.bool,
    // default: false, if true border-top-right-radius will be set
    roundCornerTopRight: PropTypes.bool,
    // default: true, if false then the menu will be dropped above the SubMenuItem
    isDroppedDown: PropTypes.bool,
    // default: true, if false then start pos will be above
    below: PropTypes.bool,
    // If true icon and content is flexed
    flex: PropTypes.bool,
    // If true the theme will be darkBLue
    darkTheme: PropTypes.bool,
    // If true then a border wil be visible
    border: PropTypes.bool,
    // If true then the screen will not be dimmed
    disableDimScreen: PropTypes.bool,
    // Special color of the icon
    color: PropTypes.string,
    // If true, the menu is disabled
    disabled: PropTypes.bool
};
SubMenuItem.defaultProps = {
    side: "left",
    roundCornerTopLeft: false,
    roundCornerTopRight: false,
    interactive: true,
    isDroppedDown: true,
    below: true,
    darkTheme: false,
    border: true,
    disableDimScreen: false,
    color: undefined,
};

/**
 * Retunerare en submeny
 * 
 * @param {object} props
 * @returns {node}
 */
export function SubMenu({border, children, style}) {
    return (
        <div className={`sub-menu ${border?"border":""}`} style={style}>
            {children}
        </div>
    );
}
SubMenu.propTypes = {
    children: PropTypes.node,
    // default: true, can be false if no bottom border is desiered
    border: PropTypes.bool,
    // custom style for the SubMenu div
    style: PropTypes.object,
};
SubMenu.defaultProps = {
    border: true,
};